// Import CSS files first to ensure they are loaded early
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, FirebaseAppProvider, FirestoreProvider } from 'reactfire';

import { ConfirmProvider } from 'material-ui-confirm';

import App from './components/App';
import { NetworkErrorBoundary } from './components/NetworkErrorBoundary';
import './styles/fonts.css';
import './styles/icons.css';
import './styles/main.css';
import { initAnalytics } from './utils/analytics/analytics';
import { IS_DEV_BASE_URL, IS_LOCAL_BASE_URL, IS_PROD_BASE_URL } from './utils/env';
import { firebaseAuth, firebaseConfig, firestoreDb } from './utils/firebaseUtils';
import { store } from './utils/store';
import { ApplyTheme } from './utils/theme';

// redirect to "aiter.io" if not already there, not DEV, not local
if (!IS_LOCAL_BASE_URL && !IS_DEV_BASE_URL && !IS_PROD_BASE_URL) {
  console.warn('Redirecting to aiter.io');
  window.location.href = 'https://aiter.io';
}

initAnalytics();

console.warn(
  `========= APP RUNNING IN ${IS_PROD_BASE_URL ? 'PROD' : 'DEV'} ENVIRONMENT ============`
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <NetworkErrorBoundary>
    <Provider store={store}>
      <ConfirmProvider>
        <ApplyTheme>
          <FirebaseAppProvider firebaseConfig={firebaseConfig}>
            <AuthProvider sdk={firebaseAuth}>
              <FirestoreProvider sdk={firestoreDb}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </FirestoreProvider>
            </AuthProvider>
          </FirebaseAppProvider>
        </ApplyTheme>
      </ConfirmProvider>
    </Provider>
  </NetworkErrorBoundary>
);
